import { type MaybeRefOrGetter, toValue } from 'vue'
import { queryOptions } from '@tanstack/vue-query'
import { fetchActivityLog } from '@/features/invoices/api/fetchActivityLog'
import { fetchInvoiceTemplate } from '@/features/invoices/api/fetchInvoiceTemplate'
import { fetchInvoice } from '@/features/invoices/api/fetchInvoice'

export const fetchActivityLogQueryOptions = (invoiceId: MaybeRefOrGetter<number>) => queryOptions({
  queryKey: ['invoices:activity', invoiceId],
  queryFn: () => fetchActivityLog(toValue(invoiceId))
})

export const fetchInvoiceTemplateQueryOptions = (assetCode: MaybeRefOrGetter<string>) => queryOptions({
  queryKey: ['invoices:config', assetCode],
  queryFn: () => fetchInvoiceTemplate(toValue(assetCode)),
})

export const fetchInvoiceQueryOptions = (invoiceId: MaybeRefOrGetter<number>) => queryOptions({
  queryKey: ['invoices', invoiceId],
  queryFn: () => fetchInvoice(toValue(invoiceId))
})
